import axios from '@axios'
import Vue from 'vue'

const emptyTotals = () => ({
  purchase_total: 0,
  sale_total: 0,
  commission_total: 0,
  commission_pct: 0,
  products_count: 0,
  suppliers_count: 0,
  quotes_count: 0,
})

const state = () => ({
  byProduct: [],
  bySupplier: [],
  totals: emptyTotals(),
  supplierOptions: [],
  groupBy: 'product',
  filters: {
    month: null,
    search: '',
    supplier_id: null,
  },
  loading: false,
  loaded: false,
})

const getters = {
  suppliesExplosionByProduct(state) {
    return state.byProduct
  },
  suppliesExplosionBySupplier(state) {
    return state.bySupplier
  },
  suppliesExplosionGroups(state) {
    return state.groupBy === 'supplier' ? state.bySupplier : state.byProduct
  },
  suppliesExplosionTotals(state) {
    return state.totals
  },
  suppliesExplosionFilters(state) {
    return state.filters
  },
  suppliesExplosionGroupBy(state) {
    return state.groupBy
  },
  suppliesExplosionSupplierOptions(state) {
    return state.supplierOptions
  },
  suppliesExplosionLoading(state) {
    return state.loading
  },
  suppliesExplosionLoaded(state) {
    return state.loaded
  },
}

const mutations = {
  SET_SUPPLIES_EXPLOSION(state, payload) {
    state.byProduct = Array.isArray(payload?.by_product) ? payload.by_product : []
    state.bySupplier = Array.isArray(payload?.by_supplier) ? payload.by_supplier : []
    state.totals = payload?.totals || emptyTotals()
    state.loaded = true
  },

  SET_SUPPLIES_EXPLOSION_SUPPLIER_OPTIONS(state, groups) {
    state.supplierOptions = (groups || [])
      .filter(group => group.key)
      .map(group => ({ value: group.key, text: group.name }))
      .sort((a, b) => String(a.text).localeCompare(String(b.text), 'es'))
  },

  SET_SUPPLIES_EXPLOSION_LOADING(state, value) {
    state.loading = !!value
  },

  SET_SUPPLIES_EXPLOSION_FILTER(state, { field, value }) {
    if (!Object.prototype.hasOwnProperty.call(state.filters, field)) return
    Vue.set(state.filters, field, value)
  },

  SET_SUPPLIES_EXPLOSION_GROUP_BY(state, value) {
    state.groupBy = value === 'supplier' ? 'supplier' : 'product'
  },
}

const actions = {
  async fetchSuppliesExplosion({ commit, state }) {
    commit('SET_SUPPLIES_EXPLOSION_LOADING', true)
    try {
      const params = {}
      const { month, search, supplier_id: supplierId } = state.filters

      if (month) params.month = month
      if (search) params.search = search
      if (supplierId) params.supplier_id = supplierId

      const { data } = await axios.get('/v1/supplies_explosion', { params })
      commit('SET_SUPPLIES_EXPLOSION', data)

      if (!supplierId) {
        commit('SET_SUPPLIES_EXPLOSION_SUPPLIER_OPTIONS', data?.by_supplier)
      }

      return data
    } finally {
      commit('SET_SUPPLIES_EXPLOSION_LOADING', false)
    }
  },

  setSuppliesExplosionFilter({ commit }, { field, value }) {
    commit('SET_SUPPLIES_EXPLOSION_FILTER', { field, value })
  },

  setSuppliesExplosionGroupBy({ commit }, value) {
    commit('SET_SUPPLIES_EXPLOSION_GROUP_BY', value)
  },

  clearSuppliesExplosionFilters({ commit, dispatch, state }) {
    commit('SET_SUPPLIES_EXPLOSION_FILTER', { field: 'search', value: '' })
    commit('SET_SUPPLIES_EXPLOSION_FILTER', { field: 'supplier_id', value: null })
    commit('SET_SUPPLIES_EXPLOSION_FILTER', { field: 'month', value: state.filters.month })
    return dispatch('fetchSuppliesExplosion')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
